import { tv } from 'tailwind-variants';

export const timelineEventStyle = tv({
  slots: {
    base: 'group flex items-stretch',
    box: 'pb-4 pl-2',
    pointBox: 'relative w-6 shrink-0 border-l border-solid border-l-stroke',
    point:
      'absolute top-0.5 flex h-5 w-5 -translate-x-1/2 transform items-center justify-center rounded-full bg-white',
    pointCircle:
      'h-full w-full rounded-full border-[3px] border-solid border-current',
    pointIcon: 'size-[18px]'
  },

  variants: {
    color: {
      primary: {
        point: 'text-primary'
      },
      secondary: {
        point: 'text-secondary'
      },
      tertiary: {
        point: 'text-tertiary'
      },
      black: {
        point: 'text-black'
      },
      success: {
        point: 'text-success'
      },
      good: {
        point: 'text-good'
      },
      neutral: {
        point: 'text-neutral'
      },
      info: {
        point: 'text-info'
      },
      error: {
        point: 'text-error'
      },
      warning: {
        point: 'text-warning'
      }
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
